export const addressFieldStyles = {
    // ---- Toolbar ----
    toolbar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 8,
        gap: 8,
        flexWrap: 'wrap',
    },
    searchInput: {
        flex: 1,
        minWidth: 120,
    },

    // ---- AddressCard ----
    card: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        padding: 8,
        borderRadius: 8,
        backgroundColor: '#FFFFFF',
        marginBottom: 8,
        cursor: 'pointer',
        border: '1px solid #EDEDED',
        gap: 8,
        '&:hover': {
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
    },
    radio: {
        flexShrink: 0,
        paddingTop: 2,
        color: '#111111',
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: 0,
        '& .ant-radio-wrapper': {
            display: 'flex',
            alignItems: 'flex-start',
        },
    },
    info: {
        flex: 1,
        minWidth: 0,
        paddingLeft: 4,
    },
    infoName: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600,
        fontSize: 14,
        color: '#111111',
        marginBottom: 4,
        gap: 4,
    },
    infoDetails: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: 16,
        fontSize: 12,
        color: '#555555',
        lineHeight: 1.6,
        '@media (max-width: 520px)': {
            flexDirection: 'column',
        },
    },
    addressBlock: {
        flex: 1,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        wordBreak: 'break-word' as const,
    },
    contactBlock: {
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'right' as const,
        wordBreak: 'break-word' as const,
        '@media (max-width: 520px)': {
            textAlign: 'left' as const,
        },
    },
    actions: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        flexShrink: 0,
    },

    // ---- AddressDetailsModal ----
    detailsSection: {
        marginBottom: 16,
    },
    detailsSectionTitle: {
        fontSize: 11,
        fontWeight: 600,
        color: '#888888',
        textTransform: 'uppercase' as const,
        letterSpacing: 0.5,
        marginBottom: 8,
    },
    detailsRow: {
        display: 'flex',
        flexDirection: 'row',
        gap: 16,
        fontSize: 13,
        padding: '6px 0',
        alignItems: 'baseline',
    },
    detailsLabel: {
        flex: '0 0 150px',
        color: '#3D3D3D',
        fontWeight: 500,
        fontSize: 12,
        textTransform: 'capitalize' as const,
    },
    detailsValue: {
        flex: 1,
        color: '#111111',
        fontWeight: 500,
        wordBreak: 'break-word' as const,
    },

    // ---- EditAddressFields ----
    addressFieldsGrid: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
    },
    chooseSavedAddressLink: {
        display: 'inline-block',
        marginBottom: 12,
        fontSize: 14,
        fontWeight: 600,
        padding: 0,
        height: 'auto',
    },

    // ---- main (AddressBook) ----
    addressWrapper: {
        alignItems: 'top',
        width: '100%',
    },
    addressList: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        maxHeight: 'calc(100vh - 340px)',
        minHeight: 200,
        padding: 8,
        '@media (max-width: 768px)': {
            maxHeight: 'calc(100vh - 300px)',
            minHeight: 150,
        },
    },
    formItem: {
        '& .ant-form-item': {
            marginBottom: 0,
        },
    },
    errorMessage: {
        color: 'red',
        fontSize: 12,
        paddingBottom: 8,
        fontWeight: 400,
    },
    savedAddressSection: {
        marginBottom: 12,
    },
    savedAddressLabel: {
        display: 'inline-block',
        fontSize: 12,
        fontWeight: 600,
        color: '#666666',
        marginBottom: 6,
    },
};
